import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import * as XLSX from 'xlsx';
import { APICallStatus, EmailSearchfor, UMPAction, UMPCategory, Utils } from '../../../../../utils/utils';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { usercreatexternal } from '../../../../../interfaces/usermanagementportal/usercreateexternal';
import { UserManagePersonaeChangelogViewModel } from '../../../../../interfaces/UserManagePersonaeChangelogViewModel';
import { ComponentTool } from 'src/app/interfaces/componenttool';
type AOA = any[][];

interface Role {
    id: string,
    persona: string
}

interface Node {
    id: string,
    text: string
}

const ApiURL = '/api/';
const existingUserMessage = 'Existing user. No action will be taken';

@Component({
    selector: "tkebulkextuser",
    templateUrl: './tkebulkextuser.component.html',
    styleUrls: ['./tkebulkextuser.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class TKEBulkExtComponent implements OnInit {
    @Input('tenants') tenants: SelectList[] = [];
    @Output() onBulkCreateUserTrigger = new EventEmitter<boolean>();
    @Output() onBackTrigger = new EventEmitter();


    public uploader!: FileUploader
    public hasBaseDropZoneOver: boolean = false;
    public hideBulkTable: boolean = true;
    public isButtonDisabled: boolean = true;
    public showAllSuccessfullyValidated: boolean = false;
    public fileName: string = '';
    public fileSize: number = 0;
    isfilePreloadError = false;
    tableResponseState: APICallStatus = APICallStatus.NotRequested;
    public headerRow: any[];
    public hiddenIdsSheetName: string | undefined = '';
    sectionPermissionPair: { [RoleType: string]: boolean } = {}; // saving the permissions for each section (EMT, Branch, MAX_Role)

    allAvlblEmtRoles: [IsVisible: boolean, Roles: Role[]] = [false, []]; // saving all the availables EmtRoles
    allAvlblMaxRoles: [IsVisible: boolean, Roles: Role[]] = [false, []]; // saving all the availables MaxRoles
    allAvlblBranches: [IsVisible: boolean, Branches: Node[]] = [false, []]; // saving all the availables Branches

    compulsoryTenantFields = ['Email', 'FirstName', 'LastName', 'DisplayName', 'CompanyName', 'PrimaryTenant'];
    compulsoryUsageLocationFields = ['Email', 'FirstName', 'LastName', 'DisplayName', 'CompanyName', 'UsageLocation'];
    specialFields = ['EMT Role', 'Branch', 'MAX_Role'] //these are acceptad values for role the code is pretty dynamic to adapt to new roles
    preLoadErrorMsg = '';

    verificationMessage: string = "";
    constructor(private http: HttpClient
        , @Inject('BASE_URL') private baseUrl: string
        , public defaults: DefaultValuesService
    ) {
        this.headerRow = [];
        //Check the permission required for each section (Roles)(Made this way for scalability)
        this.sectionPermissionPair = {
            'EMT': this.defaults.isEMTManagerUser,
            'Branch': this.defaults.stage == 1 ? this.defaults.isProdUserManagementPortalUser : this.defaults.isDevUserManagementPortalUser,
            'MAX_Role': this.defaults.stage == 1 ? this.defaults.isProdUserManagementPortalUser : this.defaults.isDevUserManagementPortalUser
        };
    }

    get isLoading(): boolean {
        return this.tableResponseState === APICallStatus.Waiting4Response;
    }

    ngOnInit() {
        this.uploader = new FileUploader({
            url: ApiURL,
            autoUpload: true,
            allowedFileType: ['xlsx']
        });
        this.uploader.onAfterAddingFile = f => {
            if (this.uploader.queue.length > 1) {
                this.uploader.removeFromQueue(this.uploader.queue[0]);
            }
        };
        this.uploader.onWhenAddingFileFailed = (item) => {
        }
    }
    fileObject: any;
    public fileOverBase(e: any): void {
        this.hasBaseDropZoneOver = e;
    }

    data: AOA = [[], []];
    dataauthor: AOA = [[], []];
    validData: AOA = [[], []];
    wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };


    async onFileChange(evt: any) {
        this.tableResponseState = APICallStatus.Waiting4Response;
        this.hideBulkTable = true;
        this.showAllSuccessfullyValidated = false;
        this.isfilePreloadError = false;
        const files: FileList | null = evt;
        const file = files?.item(0) as File
        this.hiddenIdsSheetName = '';
        if (file !== null) {
            this.fileName = file.name;
            this.fileSize = file.size;
        }
        /* wire up file reader */
        // const target: DataTransfer = evt.target as DataTransfer;
        if (evt.length !== 1) {
            throw new Error('Cannot use multiple files');
        }
        this.resetSpecialColums();
        await this.importExcelDoc(evt);
    }

    async importExcelDoc(event: any) {
        await this.parseExcelDoc(event[0]).catch(err => console.error(err));
    }

    parseExcelDoc(file: File): Promise<any> {
        /* wire up file reader */
        let fileReader = new FileReader();
        return new Promise((resolve, reject) => {
            fileReader.onload = async (e: any) => {
                /* read workbook */
                const bstr: string = e.target.result;
                const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

                /* grab first sheet */
                const wsname: string = wb.SheetNames[0];
                const ws: XLSX.WorkSheet = wb.Sheets[wsname];

                // grab hidden_author
                const wsnameauthor = wb.SheetNames.find(name => name === "hidden_author");
                const wsauthor: XLSX.WorkSheet | undefined = wsnameauthor ? wb.Sheets[wsnameauthor] : undefined;

                this.data = await XLSX.utils.sheet_to_json(ws, { range: 0, header: 1, blankrows: false }) as AOA;
                if (wsauthor) {
                    this.dataauthor = XLSX.utils.sheet_to_json(wsauthor, { range: 0, header: 1, blankrows: false }) as AOA;
                } else {
                    this.dataauthor = [[], []];
                }

                this.headerRow = this.data[0];

                // grab hidden_ids
                this.hiddenIdsSheetName = wb.SheetNames.find(name => name === "hidden_ids");

                if (await this.verifyTemplate()) {
                    if (await this.checkAndPopulRoles(this.data[0]))//Everytime file is uploaded we populate dictionary with all valid values of roles
                    {
                        this.data = this.data.slice(1); // We skip headers row
                        this.bulkVerification(); // Adds a 6th Second instead row with verifications and also puts the tenants in uppercase
                    }
                }
                resolve(this.data);
            }
            fileReader.onerror = reject;
            fileReader.readAsArrayBuffer(file);
        });
    };

    getColor(message, index) {
        if (index == 1) {
            if (message === 'Success')
                return 'green';
            else if (message === existingUserMessage)
                return 'orange';
            else
                return 'red';
        }
        else
            return null;
    }

    bulkVerification() {
        const emaiPattern: RegExp = /@tkelevator\.com$/i;
        for (let i = 0; i < this.data.length; i++) {
            //let message = "";
            this.verificationMessage = "";
            if (this.data[i].length < 1)
                continue;
            if (this.data[i].length < 1) {
                this.verificationMessage = 'Invalid Primary Tenant';
            }
            // if the required fields are present we will continue to verify further 
            if (this.rowRequired(this.data[i])) {
                this.verificationMessage = this.validateVariantFields(this.data[i]);
            }
            this.data[i].splice(1, 0, this.verificationMessage);
        }

        //if (this.data.filter(d => Object.keys(d).length > 0).some(d => d[1] === 'Success')) {
        //    Utils.httpGetUsersGroupListByFilter(
        //        this.http
        //        , this.baseUrl
        //        , {
        //            "Page": 0,
        //            "PageSize": 5,
        //            "UserPrincipalName": "",
        //            "GivenName": "",
        //            "CdpGroup": [""],
        //            "NodeId": [""],
        //            "Tenant": tenantArray.map(t => t),
        //            "MailO356Account": this.data.filter(d => d[1] === 'Success').map(d => d[0]).join(','),
        //            "EmailSearchFor": EmailSearchfor.UserCreation
        //        }, this
        //        , function (tthis: TKEBulkExtComponent, data: UserList) {
        //            if (data) {
        //                tthis.tableResponseState = APICallStatus.ResponseDataOk;
        //                if (data.users !== undefined && data.users.length > 0 || data.allowedNewUserType?.length > 0) {
        //                    for (let i = 0; i < tthis.data.length; i++) {
        //                        if (data.allowedNewUserType?.length > 0) {
        //                            let showError = true
        //                            data?.allowedNewUserType.forEach(type => {
        //                                var typedot = type == '' ? type : '.' + type
        //                                tthis.data[i][0].toLocaleLowerCase().includes(`${typedot}@tkelevator.com`) ? showError = false : null
        //                            })
        //                            if (showError) {
        //                                tthis.data[i][1] = `Only Allowed ${data?.allowedNewUserType.join('/')} emails`;
        //                                break;
        //                            }
        //                        }
        //                        if (data.users !== undefined && data.users.length > 0) {

        //                            if (data.users.some(x => x.userPrincipalName === tthis.data[i][0] && tthis.data[i][1] === 'Success'))
        //                                tthis.data[i][1] = existingUserMessage;
        //                        }
        //                    }
        //                }
        //            }
        //            else
        //                tthis.tableResponseState = APICallStatus.ResponseEmptyOk;

        //            tthis.validateCreate();
        //        }
        //        , this.defaults.isDataAnalytStage()
        //    )
        //}
        //else {
        this.tableResponseState = APICallStatus.ResponseDataOk;
        this.validateCreate();
        //}
    }

    validateCreate() {
        this.validData = this.data.filter(d => Object.keys(d).length > 0 && d[1] === 'Success');
        this.data = this.data.filter(d => Object.keys(d).length > 0 && d[1] !== 'Success');
        this.showAllSuccessfullyValidated = this.validData.length > 0 && this.data.length == 0;
        this.isButtonDisabled = this.validData.length == 0;
        this.hideBulkTable = this.data.length == 0;
    }

    stringInArray(arr: string[], str: string): boolean {
        return arr.some((item) => item.toUpperCase() === str.toUpperCase());
    }


    rowRequired(row) {
        const missing = this.compulsoryFields.find((_, i) => !row[i])
        if (missing) {
            this.verificationMessage = `${missing} is a required field`;
            return false;
        }

        if (row.length >= 7) {
            // We can have or not having {EMT, Branch, MAX_Role}
            //if there are more column than 6 we assum that we have roles and then using the dictionary we verify that the roles/branches exist
            var allRoleBranchesVerified = true;
            let colIndex = 6;
            for (let index = colIndex; index < row.length; index++) {
                switch (this.headerRow[index]) {
                    case "EMT Role": {
                        this.allAvlblEmtRoles["IsVisible"] = true;
                        if (row[index]) {
                            var roleFound = false
                            //searching in the EMT roles: [{competitor},{admin}]....
                            for (let role of this.allAvlblEmtRoles["Roles"]) {
                                if (role.persona.trim() == row[index].trim() || !row[index]) {
                                    roleFound = true
                                    break;
                                }
                            }
                            if (!roleFound) {
                                this.verificationMessage += !this.verificationMessage ? `InValid EMT Role` : ',\nInValid EmT Role';
                                allRoleBranchesVerified = false;
                            }
                        }
                        break;
                    }
                    case "Branch": {
                        this.allAvlblBranches["IsVisible"] = true;
                        if (row[index]) {
                            var branchFound = false
                            //searching in the branches
                            for (let branch of this.allAvlblBranches["Branches"]) {
                                if (branch.text.trim() == row[index].trim() || !row[index]) {
                                    branchFound = true
                                    break;
                                }
                            }
                            if (!branchFound) {
                                this.verificationMessage += !this.verificationMessage ? `InValid Branch` : `,\nInValid Branch`;
                                allRoleBranchesVerified = false;
                            }
                        }
                        break;
                    }
                    case "MAX_Role": {
                        this.allAvlblMaxRoles["IsVisible"] = true;
                        if (row[index]) {
                            var roleFound = false
                            //searching in the MAX roles
                            for (let role of this.allAvlblMaxRoles["Roles"]) {
                                if (role.persona.trim() == row[index].trim() || !row[index]) {
                                    roleFound = true
                                    break;
                                }
                            }
                            if (!roleFound) {
                                this.verificationMessage += !this.verificationMessage ? `InValid Max Role` : `,\nInValid Max Role`;
                                allRoleBranchesVerified = false;
                            }
                        }
                        break;
                    }
                    default: {
                        this.verificationMessage = !this.verificationMessage ? "Could not Verify Roles" : ",\nCould not Verify Roles";
                        allRoleBranchesVerified = false;
                    }
                }
            }
            return allRoleBranchesVerified;
        }

        else {
            return true;
        }
    }


    bulkUsers() {
        let externalUsers: usercreatexternal[] = []

        this.validData.forEach((obj: string[]) => {
            if (obj.length > 0)
                externalUsers.push(
                    this.defaults.componentTool === ComponentTool.Rulebook
                        ? {
                            email: obj[0],
                            firstName: obj[2],
                            lastName: obj[3],
                            displayName: obj[4],
                            primaryTenant: obj[6],
                            companyName: obj[5],
                            usageLocation: null,
                            UMPChangelogViewModel: obj.length > 7 ? this.populateUmpChangLogObject(obj) : [],
                        }
                        : {
                            email: obj[0],
                            firstName: obj[2],
                            lastName: obj[3],
                            displayName: obj[4],
                            primaryTenant: null,
                            companyName: obj[5],
                            UMPChangelogViewModel: obj.length > 7 ? this.populateUmpChangLogObject(obj) : [],
                            usageLocation: obj[6],
                        });

        })

        externalUsers = this.filterUniqueByEmailAndPersonae(externalUsers);

        if (externalUsers.length > 0) {
            Utils.httpCreateBulkExternalUsers(
                this.http
                , this.baseUrl
                , externalUsers
                , this
                , function (tthis: TKEBulkExtComponent, data: boolean) {
                    tthis.onBulkCreateUserTrigger.emit(data);
                }
            )
        }
    }

    filterUniqueByEmailAndPersonae(list: usercreatexternal[]): usercreatexternal[] {
        const emailMap = new Map<string, usercreatexternal>();

        for (const item of list) {
            if (!emailMap.has(item.email)) {
                // If email is not yet in the map, add it with unique personae
                const uniquePersonae = new Map<string, UserManagePersonaeChangelogViewModel>();
                item.UMPChangelogViewModel?.forEach(b => {
                    if (!uniquePersonae.has(b.Personae[0])) {
                        uniquePersonae.set(b.Personae[0], b);
                    }
                });

                emailMap.set(item.email, {
                    ...item,
                    UMPChangelogViewModel: Array.from(uniquePersonae.values()),
                });
            } else {
                // Email already exists, merge B lists without duplicating personae
                const existing = emailMap.get(item.email)!;
                const uniquePersonae = new Map<string, UserManagePersonaeChangelogViewModel>();

                // Add existing personae first
                existing.UMPChangelogViewModel?.forEach(b => uniquePersonae.set(b.Personae[0], b));

                // Add new personae if not already present
                item.UMPChangelogViewModel?.forEach(b => {
                    if (!uniquePersonae.has(b.Personae[0])) {
                        uniquePersonae.set(b.Personae[0], b);
                    }
                });

                // Update the entry in the map
                emailMap.set(item.email, {
                    ...existing,
                    UMPChangelogViewModel: Array.from(uniquePersonae.values()),
                });
            }
        }

        return Array.from(emailMap.values());
    }


    populateUmpChangLogObject(row) {
        const UMPChangelogViewModel: UserManagePersonaeChangelogViewModel[] = [];

        const roleTypeMap = {
            "emt role": { collection: this.allAvlblEmtRoles['Roles'], prop: 'persona' },
            "branch": { collection: this.allAvlblBranches['Branches'], prop: 'text' },
            "max_role": { collection: this.allAvlblMaxRoles['Roles'], prop: 'persona' }
        };

        for (let index = 6; index < this.headerRow.length; index++) {
            const rowIndex = index + 1; // To skip validation column
            const header = this.headerRow[index].toLowerCase();
            const mapEntry = roleTypeMap[header];
            if (!mapEntry || !row[rowIndex]) continue;

            for (const item of mapEntry.collection) {
                if (item[mapEntry.prop]?.trim() === row[rowIndex]?.trim() || !row[rowIndex]) {
                    UMPChangelogViewModel.push({
                        Personae: [item.id],
                        UmpAction: UMPAction.Assign,
                        UmpCategory: this.getCategory(this.headerRow[index]),
                        Type: 0
                    });
                }
            }
        }
        return UMPChangelogViewModel;
    }

    getCategory(roleType) {
        let resp = UMPCategory.None
        switch (roleType) {
            case "EMT Role": {
                resp = UMPCategory.EmtRoles
                break;
            }
            case "Branch": {
                resp = UMPCategory.BranchHierarchy
                break;
            }
            case "MAX_Role": {
                resp = UMPCategory.MaxRoles
                break;
            }
        }
        return resp
    }

    backButtonHandler(event: any) {
        event.preventDefault();
        this.onBackTrigger.emit();
    }


    getexcelfile() {
        Utils.httpGetBulkUserExcelTemplate(
            this.http
            , this.baseUrl
            , this
            , function (tthis: TKEBulkExtComponent, data: any) {
                Utils.downloadBlobFile(data, 'BulkUserTemp.xlsx')
            }
        )
    }

    async checkAndPopulRoles(row) {
        if (row.length >= 7) {
            for (let index = 6; index < row.length; index++) {
                try {
                    switch (this.headerRow[index]) {
                        case 'EMT Role': {
                            const groupData = await this.funcGetEmtRoles(row[index].split(" ")[0])
                            this.allAvlblEmtRoles["Roles"] = groupData.personae;
                            break;
                        }
                        case 'Branch': {
                            const branchData = await this.funcGetBranches(row[index].split(" ")[0])
                            this.allAvlblBranches["Branches"] = branchData;
                            break;
                        }
                        case 'MAX_Role': {
                            const groupData = await this.funcGetMaxRoles(row[index].split(" ")[0])
                            this.allAvlblMaxRoles["Roles"] = groupData;
                            break;
                        }
                    }

                }
                catch (error) {
                    this.customError(error);
                    return false
                }
            }
        }
        return true
    }

    async funcGetEmtRoles(roleType): Promise<any> {
        let response
        if (this.sectionPermissionPair[roleType]) {
            const url = this.baseUrl + Utils.getUMPUser() + "/allrelatedroles/" + roleType.toLowerCase() + 'role';
            response = await this.http.get<any>(url).toPromise();
            if (!response || (Array.isArray(response) && response.length === 0)) {
                this.tableResponseState = APICallStatus.ResponseEmptyOk;
                throw new Error(`No data found for ${roleType}`);
            }
        }
        else {

            throw new Error(`FileError: Insufficient permissions:: You do not have permissions for ${roleType} assignment. Download the bulk template again.`);
        }
        return response;
    }

    async funcGetMaxRoles(roleType): Promise<any> {
        let response
        if (this.sectionPermissionPair[roleType]) {
            const url = this.baseUrl + Utils.getUMPUser() + "/getMaxRoles";
            response = await this.http.get<any>(url).toPromise();
            if (!response || (Array.isArray(response) && response.length === 0)) {
                this.tableResponseState = APICallStatus.ResponseEmptyOk;
                throw new Error(`No data found for ${roleType}`);
            }
        }
        else {

            throw new Error(`FileError: Insufficient permissions:: You do not have permissions for ${roleType} assignment. Download the bulk template again.`);
        }
        return response;
    }
    async funcGetBranches(roleType): Promise<any> {
        let response
        if (this.sectionPermissionPair[roleType]) {
            const url = this.baseUrl + Utils.getUMPUser() + "/getBranchesBulk";
            response = await this.http.get<any>(url).toPromise();
            if (!response || (Array.isArray(response) && response.length === 0)) {
                this.tableResponseState = APICallStatus.ResponseEmptyOk;
                throw new Error(`No data found for ${roleType}`);
            }
        }
        else {

            throw new Error(`FileError: Insufficient permissions:: You do not have permissions for ${roleType} assignment. Download the bulk template again.`);
        }
        return response;
    }


    async verifyTemplate() {
        if (this.defaults.componentTool !== ComponentTool.Mersy && !await this.checkAuthorBulk()) {
            if (!this.isDataAuthorEmpty()) {
                this.errorManager('UserMismatchAuthor')
            }
            return false;
        }

        const headerset = new Set(this.headerRow);
        if (headerset.size !== this.headerRow.length) {
            this.errorManager('RepeatedHeaders')
            return false;
        }

        for (let i = 0; i < this.compulsoryFields.length; i++) {
            if (this.compulsoryFields[i] !== this.headerRow[i]) {
                this.errorManager('CompulsoryFieldMissing');
                return false;
            }
        }
        if (this.headerRow.length >= 7) {
            for (let index = 6; index < this.headerRow.length; index++) {
                if (!this.specialFields.includes(this.headerRow[index])) {
                    this.errorManager('InValidOptionalField');
                    return false;
                }
            }
        }
        if (this.data.some(row => row.length > this.headerRow.length)) {
            this.errorManager('DataRow');
            return false;
        }
        if (this.hiddenIdsSheetName == '' || this.hiddenIdsSheetName == undefined) {
            this.errorManager('IncorrectTemplate');
            return false;
        }
        // We are limiting to 50 users per file to procces it on line
        // Header row plus 50 users --> 51 rows
        if (this.data.length > 51)
        {
            this.errorManager('Max50Users');
            return false;
        }
        return true;
    }

    customError(errorMessage) {
        this.isfilePreloadError = true;
        this.preLoadErrorMsg = errorMessage;
    }

    errorManager(errorType) {

        if (errorType == 'CompulsoryFieldMissing') {
            this.isfilePreloadError = true;
            this.preLoadErrorMsg = 'FileError: Compulsory Field Missing In Header:: Please download the template again clicking add_bulk_user_template';
        }
        else if (errorType == 'InValidOptionalField') {
            this.isfilePreloadError = true;
            this.preLoadErrorMsg = 'FileError: Invalid Optional Field In Header:: Please download the template again clicking add_bulk_user_template';
        }
        else if (errorType == 'RepeatedHeaders') {
            this.isfilePreloadError = true;
            this.preLoadErrorMsg = 'FileError: Repeated Headers:: Repeated Headers in the template.';
        }
        else if (errorType == 'DataRow') {
            this.isfilePreloadError = true;
            this.preLoadErrorMsg = 'FileError: DataRowError:: More column in data row than headers row';
        }
        else if (errorType == 'UserMismatchAuthor') {
            this.isfilePreloadError = true;
            this.preLoadErrorMsg = 'FileError: Mismatch author:: User does not match the user that downloaded the template';
        }
        else if (errorType == 'IncorrectTemplate') {
            this.isfilePreloadError = true;
            this.preLoadErrorMsg = 'FileError: Incorrect template:: Please download the template again clicking add_bulk_user_template';
        }
        else if (errorType == 'Max50Users') {
            this.isfilePreloadError = true;
            this.preLoadErrorMsg = 'FileError: Limit 50 users:: The max number of users per file is 50';
        }
    }

    async checkAuthorBulk() {
        if (!this.isDataAuthorEmpty()) {
            const param1 = encodeURIComponent(this.dataauthor[0].toString());
            const param2 = encodeURIComponent(this.dataauthor[1].toString());
            const url = `${this.baseUrl}${Utils.getUMPUser()}/checkBulkAuthor/${param1}/${param2}`;
            return await this.http.get<boolean>(url).toPromise();
        }
        else {
            this.errorManager('IncorrectTemplate');
            return false;
        }
    }

    resetSpecialColums() {
        this.allAvlblEmtRoles["IsVisible"] = false;
        this.allAvlblEmtRoles["Roles"] = [];
        this.allAvlblMaxRoles["IsVisible"] = false;
        this.allAvlblMaxRoles["Roles"] = [];
        this.allAvlblBranches["IsVisible"] = false;
        this.allAvlblBranches["Branches"] = [];
    }

    isDataAuthorEmpty(): boolean {
        return (
            !this.dataauthor ||
            this.dataauthor.length === 0 ||
            this.dataauthor.every(arr => Array.isArray(arr) && arr.length === 0)
        );
    }

    get compulsoryFields(): string[] {
        return this.defaults.componentTool !== ComponentTool.Mersy ? this.compulsoryTenantFields : this.compulsoryUsageLocationFields;
    }

    private validateVariantFields(row: any[]): string {
        if (this.defaults.componentTool === ComponentTool.Mersy) {
            row[5] = String(row[5]).trim().toUpperCase().split(' ')[0];
            return /^[A-Z]{2}$/.test(row[5])
                ? 'Success'
                : 'Invalid Usage Location (ISO 3166-1 alpha-2, e.g. AR)';
        }

        row[4] = row[4].toUpperCase();
        return this.stringInArray(this.tenants.map(x => x.value), row[4])
            ? 'Success'
            : 'Invalid Primary Tenant';
    }
}